module.exports = __webpack_public_path__ + "img/error-logo.2e65ac7c.svg";